import { Injectable, Component, ComponentRef } from '@angular/core';
import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@Injectable({
    providedIn: 'root'
})
export class FullScreenLoadingService {
    overlayRef: OverlayRef | null = null;
    portal: ComponentPortal<SpinnerComponent> | null = null;

    constructor(private readonly overlay: Overlay) {}

    hide() {
        if (this.overlayRef) {
            this.overlayRef.detach();
        }
    }

    show(overlayOnTopOfDialog = false, message = 'Loading...') {
        if (!this.overlayRef) {
            this.overlayRef = this.overlay.create({
                height: '100%',
                width: '100%'
            });
        }

        if (!this.portal) {
            this.portal = new ComponentPortal(SpinnerComponent);
        }

        if (!this.overlayRef.hasAttached()) {
            const spinnerRef: ComponentRef<SpinnerComponent> = this.overlayRef.attach(this.portal);
            spinnerRef.instance.overlayOnTopOfDialog = overlayOnTopOfDialog;
            spinnerRef.instance.message = message;
        }
    }

    showWithMessage(message: string, overlayOnTopOfDialog = false) {
        this.show(overlayOnTopOfDialog, message);
    }
}

@Component({
    template: ` <div
        class="overlay"
        [class.overlay-on-top]="overlayOnTopOfDialog">
        <mat-progress-spinner
            mode="indeterminate"
            diameter="96"></mat-progress-spinner>
        <h2>{{ message }}</h2>
    </div>`,
    styles: [
        `
            .overlay {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                z-index: 1002;
                background-color: rgba(255, 255, 255, 0.5);
                width: 100vw;
                height: 100vh;
            }
        `
    ],
    standalone: true,
    imports: [MatLegacyProgressSpinnerModule]
})
export class SpinnerComponent {
    message = 'Loading...';
    private _overlayOnTopOfDialog = false;

    set overlayOnTopOfDialog(value: boolean) {
        this._overlayOnTopOfDialog = value;
    }

    get overlayOnTopOfDialog(): boolean {
        return this._overlayOnTopOfDialog;
    }
}
